import { useSelector } from 'react-redux';

import { getPreviewCreatorLevel } from '../../../../../../selectors';

export const useCreatorLevel = () => useSelector(getPreviewCreatorLevel);
